import type * as React from 'react'
import { useStudioConfig } from './studio-config-context'

export function NsfwPlatformHidden({ children }: { children: React.ReactNode }) {
  const studioConfig = useStudioConfig()

  if (studioConfig?.isNsfwPlatform) {
    return null
  }

  return <>{children}</>
}
